import React from 'react'

export const SVG_URL = (props: { color?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
        <path
            fill={props.color || '#7d889f'}
            d="M50.1 58.9a17.1 17.1 0 0 1-4.7 16l-4 4a17.4 17.4 0 0 1-24.4 0 17.3 17.3 0 0 1 0-24.4l4-4c3.3-3.3 7.6-5.1 12.2-5.1h1.3c.8 0 1.7.2 2.5.4l2.8.7-6 6H33a10 10 0 0 0-6.9 2.9l-4 4c-3.9 4-3.9 10.4 0 14.3 4 3.9 10.4 3.9 14.3 0l4-4 .6-.6a9.7 9.7 0 0 0 2.4-6.5V62l5.9-6 .8 2.7ZM79 17a17.3 17.3 0 0 0-24.4 0l-4 4c-3.3 3.3-5.1 7.6-5.1 12.2s.2 2.6.4 3.8l.7 2.8 5.9-5.9v-1.5a10 10 0 0 1 2.4-5.7l.6-.6 4-4a10.2 10.2 0 0 1 14.4 0 10.2 10.2 0 0 1 0 14.3l-4 4a10 10 0 0 1-6.8 2.9h-1l-6 6 2.7.8 2.5.4h1.2c4.6 0 8.9-1.8 12.2-5l4-4a17.3 17.3 0 0 0 0-24.4ZM32.2 58.4a3.7 3.7 0 0 0 0 5.3 3.9 3.9 0 0 0 5.4 0l26.2-26.2a3.7 3.7 0 0 0 0-5.3 3.7 3.7 0 0 0-5.3 0L32.3 58.4Z"
        />
    </svg>
)
